module.exports = __webpack_public_path__ + "static/media/Lake_Profile_App_recording.253998a8.mp4";